export default __webpack_public_path__ + "static/media/edit-black-color-icon.6343f222.svg";